import React from "react"
import styled from "styled-components"
import { Heading, Flex, Box, Text } from "rebass"

const TwoOneBox = styled(Box)``

TwoOneBox.defaultProps = {
  pr: [0, 0, 0, 3],
  flexDirection: "column",
  width: [1, 1, 1, 1 / 2],
}

export default TwoOneBox



// WEBPACK FOOTER //
// ./src/components/TwoOneBox/index.js